export const translations = {
  en: {
    aboutText1: "Are you coming to Movistar Arena, El Campín or Estéreo Picnic? Everything is within walking distance. 15 minutes from Chapinero and 20 minutes from the International Center and El Dorado Airport. Modern studio on a high floor, up to 3 people: double bed and sofa bed. Full kitchen, WiFi, and a building with pool, gym, yoga room, coworking, bar, movie rooms, barbecue area and panoramic terrace overlooking the Andes and Simón Bolívar Park.",
    aboutText2: "Bright, modern studio on the 8th floor with natural light and views of Simón Bolívar Park. Sleeps up to 3: double bed and sofa bed. Full kitchen with oven, microwave, refrigerator with water dispenser, blender, full cookware set, and basic consumables (oil, salt, coffee). Bathroom with rain shower and bidet. Hair straightener, clothes iron, and bottle opener available. WiFi included.",
    aboutText3: "Building amenities require advance reservation via access card found in the apartment: pool, gym, yoga room, coworking, bar, 2 movie rooms, rooftop soccer court, and BBQ area.",
    aboutTitle: "About this space",
    amenitiesSubtitle: "Indicative prices, subject to building confirmation.",
    amenitiesTitle: "Book Amenities",
    amenityDate: "Date",
    amenitySuccess: "Request Sent!",
    amenitySuccessMsg: "Your request was sent. Javier will confirm availability and send the payment QR via WhatsApp.",
    availabilityStatus: "Availability Status",
    available: "Available",
    back: "Back",
    bestPrice: "Best Price",
    bookingTitle: "Direct Booking",
    brand: "Loft Bogotá | Simón Bolívar",
    cancellationText: "Bookings are confirmed. Once payment is made, we do not apply refunds. We recommend checking your dates before confirming.",
    cancellationTitle: "Cancellation policy",
    card: "Credit Card",
    cardFee: "Mercado Pago Fee",
    cardHelp: "Mercado Pago (+4%)",
    checkIn: "Check-in Date",
    checkInTime: "Arrival Time",
    checkOut: "Check-out Date",
    cleaning: "Cleaning fee",
    confirmPay: "CONFIRM AND PAY",
    copyNumber: "Copy Number",
    discount: "Stay discount",
    diveRightIn: "Dive right in",
    diveRightInDesc: "One of the few places in the area with a pool",
    downloadQR: "Download QR",
    endTime: "End Time",
    entireRentalUnit: "Entire rental unit in Bogotá, Colombia",
    extraGuests: "Extra guests",
    free: "Free",
    fullName: "Full Name",
    fullNamePlaceholder: "John Doe",
    greatLocationDesc: "Walking distance to Movistar Arena, El Campín & Estéreo Picnic",
    greatLocationTitle: "Great location",
    guests: "Number of Guests",
    guestsCount: "3 guests",
    hostedBy: "Hosted by",
    houseRulesTitle: "House rules",
    idNumber: "ID / Passport Number",
    idNumberPlaceholder: "Document number",
    idPhoto: "ID / Passport Photo",
    idPhotoHelp: "Upload a clear photo of your identification document.",
    initiatingGateway: "Initiating secure gateway...",
    insurance: "Guest insurance",
    locationTitle: "Location",
    minStay: "Minimum stay: 2 nights",
    nationality: "Nationality",
    nationalityPlaceholder: "e.g., American",
    navAmenities: "Amenities",
    navAvailability: "Availability",
    navBooking: "Booking",
    navHome: "Home",
    navRegister: "Registration",
    nearby: "Nearby",
    nights: "nights",
    occupied: "Occupied",
    offersTitle: "What this place offers",
    paymentMethod: "Payment Method",
    petFee: "Pet fee",
    petsHelp: "Additional charge per night",
    petsQuestion: "Bringing pets?",
    priceBreakdown: "Price Breakdown",
    qrSubtitle: "Complete your transfer to confirm the reservation.",
    qrTitle: "Scan Nequi QR Code",
    recipientDetails: "Recipient Details",
    reminders: "Check-in Notifications",
    remindersHelp: "I want to receive check-in reminders and access instructions via WhatsApp.",
    requestAmenity: "Request Reservation",
    required: "This field is required",
    reserveDates: "RESERVE THESE DATES",
    reserveNequi: "RESERVE WITH NEQUI",
    reserved: "Reserved",
    savings: "You save ~",
    securePayment: "Secure Card Payment",
    selectDates: "Select your arrival and departure dates",
    selfCheckInAvailable: "Self check-in available",
    selfCheckInDesc: "Check in with the building staff",
    selfCheckInTitle: "Self check-in",
    sendReceipt: "Send Receipt",
    serviceFee: "Service fee",
    showAllAmenities: "Show all 14 amenities",
    showLess: "Show less",
    showLessAmenities: "Show less amenities",
    showMore: "Show more",
    startTime: "Start Time",
    stay: "Stay",
    submit: "Complete Registration",
    submitting: "Processing...",
    subtitle: "Please complete your details for building access.",
    successDetails: "You will receive an automated WhatsApp confirmation shortly with access instructions for Edificio Manzana Tres, Apt 820.",
    successMsg: "Welcome to Loft Bogotá. Your details have been sent to building administration.",
    successTitle: "Registration Complete!",
    superhost: "Superhost",
    syncing: "Syncing availability...",
    title: "Guest Registration",
    totalToPay: "Total to Pay",
    transfer: "Transfer",
    transferHelp: "Nequi (No extra charge)",
    uploadSuccess: "Photo uploaded successfully",
    uploading: "Uploading...",
    vsAirbnb: "vs Airbnb",
    whatsapp: "WhatsApp Number",
    whatsappHelp: "Include country code (e.g., +1 234 567 8900)",
    whatsappRegistered: "Your registered WhatsApp number",
    yearsHosting: "years hosting"
  },
  es: {
    aboutText1: "¿Vienes al Movistar Arena, El Campín o Estéreo Picnic? Todo está a poca distancia. A 15 minutos de Chapinero y a 20 minutos del Centro Internacional y del Aeropuerto El Dorado. Moderno estudio en piso alto, hasta 3 personas: cama doble y sofá cama. Cocina completa, WiFi y un edificio con piscina, gimnasio, sala de yoga, coworking, bar, salas de cine, zona de barbacoa y terraza panorámica con vistas a los Andes y al Parque Simón Bolívar.",
    aboutText2: "Estudio moderno y luminoso en el piso 8 con luz natural y vistas al Parque Simón Bolívar. Capacidad hasta 3 personas: cama doble y sofá cama. Cocina completa con horno, microondas, nevera con dispensador de agua, licuadora, juego completo de utensilios de cocina y consumibles básicos (aceite, sal, café). Baño con ducha de lluvia y bidet. Plancha de pelo, plancha de ropa y abridor de botellas disponibles. WiFi incluido.",
    aboutText3: "Las comodidades del edificio requieren reserva previa mediante la tarjeta de acceso que se encuentra en el apartamento: piscina, gimnasio, sala de yoga, coworking, bar, 2 salas de cine, cancha de fútbol en la azotea y zona de barbacoa.",
    aboutTitle: "Acerca de este espacio",
    amenitiesSubtitle: "Precios orientativos, sujetos a confirmación del edificio.",
    amenitiesTitle: "Reservar Amenidades",
    amenityDate: "Fecha",
    amenitySuccess: "¡Solicitud Enviada!",
    amenitySuccessMsg: "Tu solicitud fue enviada. Javier te confirmará disponibilidad y te enviará el QR de pago por WhatsApp.",
    availabilityStatus: "Estado de Disponibilidad",
    available: "Disponible",
    back: "Volver",
    bestPrice: "Mejor Precio",
    bookingTitle: "Reserva Directa",
    brand: "Loft Bogotá | Simón Bolívar",
    cancellationText: "Las reservas son de carácter confirmado. Una vez realizado el pago, no aplicamos reembolsos. Te recomendamos verificar tus fechas antes de confirmar.",
    cancellationTitle: "Política de cancelación",
    card: "Tarjeta Crédito",
    cardFee: "Cargo Mercado Pago",
    cardHelp: "Mercado Pago (+4%)",
    checkIn: "Fecha de Entrada",
    checkInTime: "Hora de llegada",
    checkOut: "Fecha de Salida",
    cleaning: "Tarifa de limpieza",
    confirmPay: "CONFIRMAR Y PAGAR",
    copyNumber: "Copiar Número",
    discount: "Descuento por estadía",
    diveRightIn: "Sumérgete",
    diveRightInDesc: "Uno de los pocos lugares en la zona con piscina",
    downloadQR: "Descargar QR",
    endTime: "Hora fin",
    entireRentalUnit: "Unidad de alquiler completa en Bogotá, Colombia",
    extraGuests: "Huéspedes adicionales",
    free: "Libre",
    fullName: "Nombre Completo",
    fullNamePlaceholder: "Juan Pérez",
    greatLocationDesc: "A poca distancia de Movistar Arena, El Campín y Estéreo Picnic",
    greatLocationTitle: "Gran ubicación",
    guests: "Número de Huéspedes",
    guestsCount: "3 huéspedes",
    hostedBy: "Anfitrión",
    houseRulesTitle: "Reglas de la casa",
    idNumber: "Cédula / Pasaporte",
    idNumberPlaceholder: "Número de documento",
    idPhoto: "Foto del Documento",
    idPhotoHelp: "Suba una foto clara de su documento de identidad.",
    initiatingGateway: "Iniciando pasarela segura...",
    insurance: "Seguro de huésped",
    locationTitle: "Ubicación",
    minStay: "Mínimo requerido: 2 noches",
    nationality: "Nacionalidad",
    nationalityPlaceholder: "ej., Colombiano",
    navAmenities: "Amenities",
    navAvailability: "Disponibilidad",
    navBooking: "Reserva",
    navHome: "Inicio",
    navRegister: "Registro",
    nearby: "Cerca de",
    nights: "noches",
    occupied: "Ocupado",
    offersTitle: "Lo que este lugar ofrece",
    paymentMethod: "Método de Pago",
    petFee: "Tarifa de mascota",
    petsHelp: "Cargo adicional por noche",
    petsQuestion: "¿Traes mascotas?",
    priceBreakdown: "Desglose de Precios",
    qrSubtitle: "Completa tu transferencia para confirmar la reserva.",
    qrTitle: "Escanea el Código QR de Nequi",
    recipientDetails: "Detalles del Destinatario",
    reminders: "Notificaciones de Llegada",
    remindersHelp: "Deseo recibir recordatorios de llegada e instrucciones de acceso por WhatsApp.",
    requestAmenity: "Solicitar reserva",
    required: "Este campo es obligatorio",
    reserveDates: "RESERVAR ESTAS FECHAS",
    reserveNequi: "RESERVAR CON NEQUI",
    reserved: "Reserved",
    savings: "Ahorras ~",
    securePayment: "Pago Seguro con Tarjeta",
    selectDates: "Selecciona tu fecha de llegada y salida",
    selfCheckInAvailable: "Auto check-in disponible",
    selfCheckInDesc: "Check-in con el personal del edificio",
    selfCheckInTitle: "Auto check-in",
    sendReceipt: "Enviar Comprobante",
    serviceFee: "Tarifa de servicio",
    showAllAmenities: "Mostrar los 14 servicios",
    showLess: "Mostrar menos",
    showLessAmenities: "Mostrar menos servicios",
    showMore: "Mostrar más",
    startTime: "Hora de inicio",
    stay: "Estadía",
    submit: "Completar Registro",
    submitting: "Procesando...",
    subtitle: "Por favor complete sus datos para el acceso al edificio.",
    successDetails: "En breve recibirá una confirmación por WhatsApp con las instrucciones de acceso para el Edificio Manzana Tres, Apto 820.",
    successMsg: "Bienvenido a Loft Bogotá. Sus datos han sido enviados a la administración.",
    successTitle: "¡Registro Completado!",
    superhost: "Superanfitrión",
    syncing: "Sincronizando disponibilidad...",
    title: "Registro de Huéspedes",
    totalToPay: "Total a Pagar",
    transfer: "Transferencia",
    transferHelp: "Nequi (Sin cargo extra)",
    uploadSuccess: "Foto subida exitosamente",
    uploading: "Subiendo...",
    vsAirbnb: "vs Airbnb",
    whatsapp: "Número de WhatsApp",
    whatsappHelp: "Incluya el código de país (ej., +57 300 123 4567)",
    whatsappRegistered: "Tu número de WhatsApp registrado",
    yearsHosting: "años como anfitrión"
  },
  pt: {
    aboutText1: "Você vem ao Movistar Arena, El Campín ou Estéreo Picnic? Tudo está a uma curta distância. 15 minutos de Chapinero e 20 minutos do Centro Internacional e do Aeroporto El Dorado. Estúdio moderno em andar alto, para até 3 pessoas: cama de casal e sofá-cama. Cozinha completa, WiFi e prédio com piscina, academia, sala de ioga, coworking, bar, salas de cinema, churrasqueira e terraço panorâmico com vista para os Andes e o Parque Simón Bolívar.",
    aboutText2: "Estúdio moderno e luminoso no 8º andar com luz natural e vista para o Parque Simón Bolívar. Acomoda até 3 pessoas: cama de casal e sofá-cama. Cozinha completa com forno, micro-ondas, geladeira com dispensador de água, liquidificador, conjunto completo de utensílios de cozinha e consumíveis básicos (óleo, sal, café). Banheiro com chuveiro de chuva e bidê. Chapinha de cabelo, ferro de passar roupa e abridor de garrafas disponíveis. WiFi incluído.",
    aboutText3: "As comodidades do edifício requerem reserva antecipada através do cartão de acesso encontrado no apartamento: piscina, academia, sala de ioga, coworking, bar, 2 salas de cinema, campo de futebol na cobertura e churrasqueira.",
    aboutTitle: "Sobre este espaço",
    amenitiesSubtitle: "Preços indicativos, sujeitos à confirmação do edifício.",
    amenitiesTitle: "Reservar Comodidades",
    amenityDate: "Data",
    amenitySuccess: "Solicitação Enviada!",
    amenitySuccessMsg: "Sua solicitação foi enviada. Javier confirmará a disponibilidade e enviará o QR de pagamento pelo WhatsApp.",
    availabilityStatus: "Status de Disponibilidade",
    available: "Disponível",
    back: "Voltar",
    bestPrice: "Melhor Preço",
    bookingTitle: "Reserva Directa",
    brand: "Loft Bogotá | Simón Bolívar",
    cancellationText: "As reservas são confirmadas. Uma vez efetuado o pagamento, não aplicamos reembolsos. Recomendamos verificar suas datas antes de confirmar.",
    cancellationTitle: "Política de cancelamento",
    card: "Cartão de Crédito",
    cardFee: "Taxa Mercado Pago",
    cardHelp: "Mercado Pago (+4%)",
    checkIn: "Data de Entrada",
    checkInTime: "Hora de Chegada",
    checkOut: "Data de Saída",
    cleaning: "Taxa de limpeza",
    confirmPay: "CONFIRMAR E PAGAR",
    copyNumber: "Copiar Número",
    discount: "Desconto por estadia",
    diveRightIn: "Mergulhe",
    diveRightInDesc: "Um dos poucos lugares na área com piscina",
    downloadQR: "Baixar QR",
    endTime: "Hora de término",
    entireRentalUnit: "Unidade de aluguel inteira em Bogotá, Colômbia",
    extraGuests: "Hóspedes adicionais",
    free: "Livre",
    fullName: "Nome Completo",
    fullNamePlaceholder: "João Silva",
    greatLocationDesc: "A uma curta distância do Movistar Arena, El Campín e Estéreo Picnic",
    greatLocationTitle: "Ótima localização",
    guests: "Número de Hóspedes",
    guestsCount: "3 hóspedes",
    hostedBy: "Anfitrião",
    houseRulesTitle: "Regras da casa",
    idNumber: "RG / Passaporte",
    idNumberPlaceholder: "Número do documento",
    idPhoto: "Foto do Documento",
    idPhotoHelp: "Envie uma foto clara do seu documento de identidade.",
    initiatingGateway: "Iniciando gateway seguro...",
    insurance: "Seguro do hóspede",
    locationTitle: "Localização",
    minStay: "Mínimo necessário: 2 noites",
    nationality: "Nacionalidade",
    nationalityPlaceholder: "ex: Brasileiro",
    navAmenities: "Comodidades",
    navAvailability: "Disponibilidade",
    navBooking: "Reserva",
    navHome: "Início",
    navRegister: "Registro",
    nearby: "Perto de",
    nights: "noites",
    occupied: "Ocupado",
    offersTitle: "O que este lugar oferece",
    paymentMethod: "Método de Pagamento",
    petFee: "Taxa de animal",
    petsHelp: "Taxa adicional por noite",
    petsQuestion: "Trazendo animais?",
    priceBreakdown: "Detalhamento de Preços",
    qrSubtitle: "Conclua sua transferência para confirmar a reserva.",
    qrTitle: "Escaneie o Código QR do Nequi",
    recipientDetails: "Detalhes do Destinatario",
    reminders: "Notificações de Chegada",
    remindersHelp: "Desejo receber lembretes de chegada e instruções de acesso pelo WhatsApp.",
    requestAmenity: "Solicitar reserva",
    required: "Este campo é obrigatório",
    reserveDates: "RESERVAR ESTAS DATAS",
    reserveNequi: "RESERVAR CON NEQUI",
    reserved: "Reserved",
    savings: "Você economiza ~",
    securePayment: "Pagamento Seguro com Cartão",
    selectDates: "Selecione suas datas de chegada e saída",
    selfCheckInAvailable: "Auto check-in disponível",
    selfCheckInDesc: "Check-in com a equipe do edifício",
    selfCheckInTitle: "Auto check-in",
    sendReceipt: "Enviar Comprovante",
    serviceFee: "Taxa de serviço",
    showAllAmenities: "Mostrar todas as 14 comodidades",
    showLess: "Mostrar menos",
    showLessAmenities: "Mostrar menos comodidades",
    showMore: "Mostrar mais",
    startTime: "Hora de início",
    stay: "Estadia",
    submit: "Completar Registro",
    submitting: "Processando...",
    subtitle: "Por favor, preencha seus dados para acesso ao edifício.",
    successDetails: "Em breve você receberá uma confirmação pelo WhatsApp com as instruções de acesso para o Edifício Manzana Tres, Apto 820.",
    successMsg: "Bem-vindo ao Loft Bogotá. Seus dados foram enviados para a administração.",
    successTitle: "Registro Concluído!",
    superhost: "Superanfitrião",
    syncing: "Sincronizando disponibilidade...",
    title: "Registro de Huéspedes",
    totalToPay: "Total a Pagar",
    transfer: "Transferência",
    transferHelp: "Nequi (Sem taxa extra)",
    uploadSuccess: "Foto enviada com sucesso",
    uploading: "Enviando...",
    vsAirbnb: "vs Airbnb",
    whatsapp: "Número do WhatsApp",
    whatsappHelp: "Inclua o código do país (ex: +55 11 91234 5678)",
    whatsappRegistered: "Seu número de WhatsApp registrado",
    yearsHosting: "anos como anfitrião"
  }
};